import classNames from 'classnames'
import { useState, useRef } from 'react'

import { ReactComponent as IconArrowSelect } from 'assets/icons/IconArrowSelect.svg'
import useClickOutside from 'hooks/useClickOutside'
import { TOptionSelectDropdown } from 'types/components'

type TProps = {
  options: TOptionSelectDropdown[]
  onChange: (option: TOptionSelectDropdown) => void
  defaultOption?: TOptionSelectDropdown
  shorter?: boolean
  disabled?: boolean
}

const SelectDropdown = ({ options, onChange, defaultOption, shorter, disabled }: TProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [selectedValue, setSelectedValue] = useState(defaultOption)

  const selectDropdownRef = useRef(null)
  const labelRef = useRef(null)

  useClickOutside(selectDropdownRef, labelRef, setIsOpen, isOpen)

  const onClickOption = (option: TOptionSelectDropdown) => {
    setSelectedValue(option)
    onChange(option)
    setIsOpen(false)
  }

  const onClickArrow = () => setIsOpen(!isOpen)

  return (
    <div
      className={classNames('selectDropdown', { '-shorter': shorter }, { '-disabled': disabled })}
      ref={selectDropdownRef}
    >
      <label
        className={classNames('selectDropdown__label', { '-disabled': disabled })}
        onClick={onClickArrow}
        role="button"
        ref={labelRef}
      >
        {selectedValue?.name ?? 'unknown'}
        <IconArrowSelect className="selectDropdown__open-icon" data-testid="open-icon" />
      </label>

      {isOpen && (
        <ul className={classNames('selectDropdown__list', { '-shorter': shorter })}>
          <IconArrowSelect
            className="selectDropdown__close-icon"
            onClick={onClickArrow}
            role="button"
            data-testid="close-icon"
          />
          {options?.map((option: TOptionSelectDropdown) => (
            <li
              key={option.uuid}
              className={classNames('selectDropdown__option', {
                '-active': option.uuid === selectedValue?.uuid,
              })}
              onClick={() => onClickOption(option)}
            >
              {option.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default SelectDropdown
